import Logout from "../components/Logout";

function LogoutPage() {
    return (
        <div><Logout /></div>
    )
}

export default LogoutPage;